import {
  Box,
  Flex,
  Grid,
  GridItem,
  Icon,
  Link,
  Text,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import { HiOutlineDownload } from 'react-icons/hi';

import { FadeIn } from '$components/ui/fade-in';
import { Section } from '$components/layout/section';
import { education, experience } from '$shared/experience';
import { social } from '$shared/social';

export function Experience() {
  return (
    <Section
      dataScroll="experience"
      eyebrow="Trajetória"
      title="Por onde passei."
    >
      {experience.map((entry, index) => (
        <FadeIn key={`${entry.company}-${index}`} delay={index * 80} mb="32px">
          <Grid
            templateColumns={{ base: '1fr', md: '140px 1fr' }}
            gap={{ base: '8px', md: '32px' }}
            role="group"
            py="20px"
            px="14px"
            mx="-14px"
            borderRadius="10px"
            transition="background 0.25s ease"
            _hover={{ bg: 'bg.surface' }}
          >
            <GridItem>
              <Text
                fontFamily="mono"
                fontSize="11px"
                letterSpacing="0.12em"
                textTransform="uppercase"
                color="text.faint"
                pt={{ md: '6px' }}
                _groupHover={{ color: 'accent.500' }}
                transition="color 0.25s ease"
              >
                {entry.period}
              </Text>
            </GridItem>

            <GridItem>
              <Text
                fontFamily="heading"
                fontWeight="600"
                fontSize={{ base: '18px', md: '20px' }}
                color="text.primary"
                lineHeight="1.15"
              >
                {entry.role}
              </Text>
              <Text
                fontFamily="body"
                fontSize="15px"
                color="text.muted"
                mt="4px"
              >
                {entry.company}, {entry.location.toLowerCase()}
              </Text>

              <Box
                as="ul"
                mt="14px"
                pl="20px"
                sx={{
                  listStyle: 'none',
                  '& li': { position: 'relative', pl: '4px' },
                  '& li::before': {
                    content: '"›"',
                    position: 'absolute',
                    left: '-16px',
                    color: 'accent.500',
                    fontFamily: 'mono',
                  },
                }}
              >
                {entry.highlights.map((line, lineIndex) => (
                  <Box
                    as="li"
                    key={lineIndex}
                    fontSize="15px"
                    color="text.muted"
                    lineHeight="1.6"
                    mb="6px"
                    _last={{ mb: 0 }}
                  >
                    {line}
                  </Box>
                ))}
              </Box>

              <Wrap spacing="6px" mt="16px">
                {entry.techs.map((tech) => (
                  <WrapItem key={tech}>
                    <Text
                      fontFamily="mono"
                      fontSize="11px"
                      letterSpacing="0.04em"
                      px="10px"
                      py="4px"
                      borderRadius="999px"
                      bg="accent.dim"
                      color="accent.500"
                    >
                      {tech}
                    </Text>
                  </WrapItem>
                ))}
              </Wrap>
            </GridItem>
          </Grid>
        </FadeIn>
      ))}

      <FadeIn>
        <Link
          href={social.resume}
          isExternal
          display="inline-flex"
          alignItems="center"
          gap="8px"
          mt="16px"
          fontFamily="mono"
          fontSize="12px"
          letterSpacing="0.08em"
          color="text.primary"
          _hover={{ color: 'accent.500', textDecoration: 'none' }}
        >
          <Icon as={HiOutlineDownload} />
          Currículo completo (PDF)
        </Link>
      </FadeIn>

      <Text
        mt="56px"
        mb="20px"
        fontFamily="mono"
        fontSize="11px"
        letterSpacing="0.18em"
        textTransform="uppercase"
        color="text.faint"
      >
        Educação
      </Text>

      {education.map((entry, index) => (
        <FadeIn key={`${entry.school}-${index}`} delay={index * 60}>
          <Grid
            templateColumns={{ base: '1fr', md: '140px 1fr' }}
            gap={{ base: '4px', md: '32px' }}
            py="14px"
            borderTopWidth="1px"
            borderColor="line.subtle"
            _last={{ borderBottomWidth: '1px' }}
          >
            <GridItem>
              <Text
                fontFamily="mono"
                fontSize="11px"
                letterSpacing="0.12em"
                textTransform="uppercase"
                color="text.faint"
              >
                {entry.period}
              </Text>
            </GridItem>
            <GridItem>
              <Text fontSize="15px" color="text.primary" fontWeight="500">
                {entry.course}
              </Text>
              <Text fontSize="13px" color="text.muted" mt="2px">
                {entry.school}, {entry.location}
              </Text>
            </GridItem>
          </Grid>
        </FadeIn>
      ))}
    </Section>
  );
}
